export const DOMArray = (selector) => {
    return [...document.querySelectorAll(selector)];
};
export function getModalDOMRoot(elementId) {
    return document.getElementById(elementId).shadowRoot;
}
//# sourceMappingURL=dom.js.map